// src/pages/Configuration.js
import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Both items are visible to every role that can reach this page (the
// Configuration nav link itself is already admin/masteradmin-only, see
// Layout.js) — unlike Reports.js there's no per-item role split to filter
// on here, so no roles array is needed.
const CONFIG_ITEMS = [
  {
    path: '/config/company-list',
    title: 'Companies',
    description: 'Manage the list of companies/subsidiaries.',
  },
  {
    path: '/config/department-list',
    title: "Company's Departments",
    description: 'Manage departments within each company/subsidiary.',
  },
  {
    path: '/config/qualification-list',
    title: 'Qualification/Role',
    description: 'Manage the list of qualifications/roles used as course prerequisites.',
  },
  {
    path: '/config/mail-settings',
    title: 'Mail Settings',
    description: 'Configure whether and how the system sends emails.',
  },
  {
    path: '/config/rate-limiting',
    title: 'Rate Limiting',
    description: 'Configure brute-force protection thresholds for Login and Forgot Password.',
  },
];

function Configuration() {
  return (
    <div className="p-2">
      <h2>Configuration</h2>
      <ListGroup>
        {CONFIG_ITEMS.map(item => (
          <ListGroup.Item key={item.path} action as={Link} to={item.path}>
            <strong>{item.title}</strong>
            <div className="text-muted">{item.description}</div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
}

export default Configuration;
